import { render, staticRenderFns } from "./ProductPromoFilter.vue?vue&type=template&id=3774b33a"
import script from "./ProductPromoFilter.vue?vue&type=script&lang=js"
export * from "./ProductPromoFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports